import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VehicleTypeListRes;
export const VehicleTypeListTodo = createAsyncThunk('VehicleTypeList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Get",
            url: process.env.REACT_APP_API_URL + 'vehicle_type',
            params:{
                "vehicle_type_status ": ""
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return VehicleTypeListRes = res.data

    } catch (error) {
        return VehicleTypeListRes = error.response.data
    }
})

const VehicleTypeListSlice = createSlice({
    name: 'VehicleTypeList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VehicleTypeListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(VehicleTypeListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VehicleTypeListSlice.reducer; 